import { getToken } from "../../utils/auth";
import { dev_baseUrl } from "../../utils/var";

export const DeleteAttachment = async (MediaType, EntityType, EntityId, mediaID, navigate) => {
  const accesstoken = getToken();
  
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/Media/delete/${MediaType}/${EntityType}/${EntityId}/${mediaID}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
        },
      });

      if (response.status === 401) { // Handle unauthorized case
        navigate(`/login`);
        return null;
      }

      if (!response.ok) {        
        console.error(`Error: ${response.status} - ${response.statusText}`);
        return { form: 'Failed to delete the file. Please try again later.' };
      }

      const data = await response; // Parse response as binary data
      // console.log(data)
      return data;

    } catch (error) {
      console.error('Network error:', error);
      return { form: 'An error occurred. Please try again later.' };
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};
